/**
 * Delivery Manager Configuration
 *
 * INSTRUCTIONS:
 * 1. Edit the values below to configure your delivery system
 * 2. Upload this file to your Shopify theme's assets folder
 * 3. No need to touch any other files!
 *
 * All times are in 24-hour format (0-23)
 * All prices are in dollars
 * Dates should be in YYYY-MM-DD format
 */

window.DELIVERY_CONFIG = {

  // ========================================
  // GENERAL SETTINGS
  // ========================================

  // Enable/disable delivery and pickup options
  delivery_enabled: true,
  pickup_enabled: true,

  // Store address (used for radius calculations)
  // Update this to your actual store address
  store_address: {
    street: '560 NW 159TH ST',
    city: 'MIAMI',
    state: 'FL',
    zip: '33169'
  },

  // Timezone (affects date/time calculations)
  // Common values: 'America/New_York', 'America/Chicago', 'America/Los_Angeles', 'America/Denver'
  timezone: 'America/New_York',

  // ========================================
  // OPERATING HOURS
  // ========================================

  // Store hours for each day (24-hour format)
  // Set closed: true for days you're closed
  operating_hours: {
    monday:    { open: '09:00', close: '21:00', closed: false },
    tuesday:   { open: '09:00', close: '21:00', closed: false },
    wednesday: { open: '09:00', close: '21:00', closed: false },
    thursday:  { open: '09:00', close: '21:00', closed: false },
    friday:    { open: '09:00', close: '21:00', closed: false },
    saturday:  { open: '09:00', close: '21:00', closed: false },
    sunday:    { open: '09:00', close: '21:00', closed: false }
  },

  // ========================================
  // SERVICE AREA & VALIDATION
  // ========================================

  // Valid ZIP codes (leave empty to allow all)
  // Supports ranges using : or - separator (e.g., '33100:33200')
  // Add multiple entries separated by commas
  // Example: ['10001', '10002', '10003:10010']
  valid_zipcodes: [
    '33100:33200',  // Main Miami range
    '33201',        // Individual ZIP
    '33210-33220'   // Range with dash separator
  ],

  // Blocked/Excluded ZIP codes (these will ALWAYS be rejected, even if in valid_zipcodes)
  // Useful for excluding specific problem areas within a larger range
  // Example: If you allow 33100:33200 but want to block 33150, add '33150' here
  blocked_zipcodes: [
    // Add ZIPs to block here, e.g.:
    // '33150',       // Specific ZIP to block
    // '33160-33165'  // Range to block
  ],

  // Maximum delivery radius in miles (for Google Maps validation)
  delivery_radius_miles: 30,

  // Enable distance-based validation (requires Google API key with Distance Matrix API enabled)
  // Set to false to only use ZIP code list validation (recommended if API not enabled)
  // If a ZIP is not in valid_zipcodes list, it will check if within radius
  radius_validation_enabled: false,

  // Google Maps API Key — DO NOT hardcode here.
  // Source of truth: Shopify Admin → Online Store → Themes → Customize → Theme settings → Google Maps API Key.
  // The live runtime reads it from the inline JSON in sections/cart-delivery-options.liquid (fed by `settings.google_maps_api_key`).
  // This fallback path is only hit if that inline JSON is missing — leave empty so secrets stay out of git. See SECRETS.md.
  google_maps_api_key: '',

  // ========================================
  // PRICING
  // ========================================

  // Minimum order amount for delivery (in dollars)
  min_order_amount: 60,

  // Free delivery threshold (orders above this amount get free delivery)
  free_delivery_threshold: 150,

  // Base delivery fee (in dollars)
  delivery_fee: 20,

  // Fee type: 'flat' or 'distance'
  // 'flat' = same fee for all deliveries
  // 'distance' = fee calculated based on distance from store
  fee_type: 'flat',

  // Distance rate (only used if fee_type is 'distance')
  // Fee = base delivery_fee + (distance_in_miles * distance_rate_per_mile)
  distance_rate_per_mile: 2,

  // ========================================
  // TIMESLOTS
  // ========================================

  // Available delivery/pickup timeslots
  // You can add, remove, or modify these slots
  timeslots: [
    {
      id: 1,
      label: '9AM - 12PM',
      start_hour: 9,   // 9:00 AM
      end_hour: 12,    // 12:00 PM
      capacity_delivery: 10,  // Max deliveries per slot
      capacity_pickup: 20,    // Max pickups per slot
      enabled: true
    },
    {
      id: 2,
      label: '12PM - 3PM',
      start_hour: 12,
      end_hour: 15,
      capacity_delivery: 15,
      capacity_pickup: 25,
      enabled: true
    },
    {
      id: 3,
      label: '3PM - 6PM',
      start_hour: 15,
      end_hour: 18,
      capacity_delivery: 12,
      capacity_pickup: 20,
      enabled: true
    },
    {
      id: 4,
      label: '6PM - 9PM',
      start_hour: 18,
      end_hour: 21,
      capacity_delivery: 8,
      capacity_pickup: 15,
      enabled: false  // Disabled by default
    }
  ],

  // ========================================
  // DATE BLOCKING
  // ========================================

  // Block specific weekdays (0=Sunday, 1=Monday, 2=Tuesday, etc.)
  // Example: [0, 6] blocks Sundays and Saturdays
  blocked_weekdays: [0],  // Sunday blocked by default

  // Block specific dates (YYYY-MM-DD format)
  // Example: ['2025-12-25', '2025-12-26', '2025-01-01']
  blocked_dates: [
    // Add your blocked dates here
    // '2025-12-25',  // Christmas
    // '2025-01-01',  // New Year's Day
  ],

  // ========================================
  // ADVANCED SETTINGS
  // ========================================

  // How many days ahead customers can select (e.g., 14 = 2 weeks)
  days_ahead_to_show: 14,

  // Latest hour to accept same-day orders (24-hour format)
  // Orders placed after this time will be for next day
  same_day_cutoff_hour: 16,  // 4:00 PM

  // Minimum preparation time in hours
  // Orders must be placed this many hours in advance
  prep_time_hours: 4,

  // Alert threshold (% of capacity before sending alerts)
  // Not implemented yet, but reserved for future use
  alert_threshold_percent: 80,

  // Admin email for notifications (future use)
  admin_email: '',

  // Enable/disable customer confirmation emails (future use)
  customer_confirmations_enabled: true,

  // Enable/disable admin notifications (future use)
  admin_notifications_enabled: true
};

// ========================================
// QUICK EXAMPLES
// ========================================

/*

EXAMPLE 1: Weekend-only delivery service
-----------------------------------------
operating_hours: {
  monday:    { closed: true },
  tuesday:   { closed: true },
  wednesday: { closed: true },
  thursday:  { closed: true },
  friday:    { closed: true },
  saturday:  { open: '09:00', close: '21:00', closed: false },
  sunday:    { open: '09:00', close: '21:00', closed: false }
}


EXAMPLE 2: ZIP code restrictions for Manhattan
-----------------------------------------------
valid_zipcodes: ['10001', '10002', '10003', '10004', '10005', '10006', '10007', '10009', '10010', '10011', '10012', '10013', '10014', '10016', '10017', '10018', '10019', '10020', '10021', '10022', '10023', '10024', '10025', '10026', '10027', '10028', '10029', '10030', '10031', '10032', '10033', '10034', '10035', '10036', '10037', '10038', '10039', '10040']


EXAMPLE 3: Distance-based pricing
----------------------------------
fee_type: 'distance',
delivery_fee: 20,           // Base fee
distance_rate_per_mile: 2,  // Additional $2 per mile
// Example: 5 miles away = $10 + (5 × $2) = $20


EXAMPLE 4: Holiday blocking
----------------------------
blocked_dates: [
  '2025-12-24',  // Christmas Eve
  '2025-12-25',  // Christmas Day
  '2025-12-26',  // Day after Christmas
  '2025-12-31',  // New Year's Eve
  '2026-01-01',  // New Year's Day
  '2026-07-04',  // Independence Day
  '2026-11-28',  // Thanksgiving
]


EXAMPLE 5: More timeslots
--------------------------
timeslots: [
  { id: 1, label: '9AM - 11AM',  start_hour: 9,  end_hour: 11, capacity_delivery: 8,  capacity_pickup: 15, enabled: true },
  { id: 2, label: '11AM - 1PM',  start_hour: 11, end_hour: 13, capacity_delivery: 10, capacity_pickup: 20, enabled: true },
  { id: 3, label: '1PM - 3PM',   start_hour: 13, end_hour: 15, capacity_delivery: 10, capacity_pickup: 20, enabled: true },
  { id: 4, label: '3PM - 5PM',   start_hour: 15, end_hour: 17, capacity_delivery: 8,  capacity_pickup: 15, enabled: true },
  { id: 5, label: '5PM - 7PM',   start_hour: 17, end_hour: 19, capacity_delivery: 6,  capacity_pickup: 12, enabled: true },
  { id: 6, label: '7PM - 9PM',   start_hour: 19, end_hour: 21, capacity_delivery: 5,  capacity_pickup: 10, enabled: true },
]

*/
